import { Pipe, PipeTransform } from '@angular/core';

import { NotificationCode } from '../models/communication/app-enums.model';

@Pipe({
    name: 'notificationText',
    standalone: true
})
export class NotificationTextPipe implements PipeTransform {
    transform(value?: NotificationCode): string {
        if (!value) {
            // eslint-disable-next-line no-console
            console.warn('Invalid notification code');
            return '';
        }

        return NotificationTextPipe.codeToText(value);
    }

    // eslint-disable-next-line consistent-return
    static codeToText(code: NotificationCode): string {
        switch (code) {
            case NotificationCode.AuthenticationFailed:
                return $localize`Authentication failed!`;
            case NotificationCode.AuthenticationSuccess:
                return $localize`Successfully authenticated!`;
            case NotificationCode.CroupierChangeInvalidState:
                return $localize`Croupier change not allowed in this game state.`;
            case NotificationCode.DuplicateCard:
                return $localize`Same round, same card detected.`;
            case NotificationCode.FlagFailed:
                return $localize`Flag failed, round not marked.`;
            case NotificationCode.InvalidCard:
                return $localize`Invalid card or card not recognized.`;
            case NotificationCode.InvalidCroupierId:
                return $localize`Invalid croupier ID for this table!`;
            case NotificationCode.ScannerDisconnected:
                return $localize`Card scanner is disconnected!`;
            case NotificationCode.ScannerConnected:
                return $localize`Card scanner is connected and ready.`;
            case NotificationCode.InvalidDealing:
                return $localize`Invalid action - dealing in wrong state!`;
            // Frontend only
            case NotificationCode.ActionFailed:
                return $localize`Action failed!`;
            case NotificationCode.CutCardDrawn:
                return $localize`Cut card drawn.`;
            case NotificationCode.ConnectionClosed:
                return $localize`Connection to table lost. Attempting to reconnect…`;
            case NotificationCode.ExpectedSupervisor:
                return $localize`Authentication failed!`;
        }
    }
}
